import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {NavLink} from 'react-router-dom';
import {withRouter} from 'react-router';

import AboutPblMenu from './AboutPblMenu.js';

const AboutPblMenuItem = ({ clang, name, children, match }) => {
    return (
        <li className="about-pbl__menu-list__item">
            <NavLink
                to={`/about/${name}`}
                title={lang[clang].about_pbl[name]}
                className="about-pbl__menu-list__item--btn">
                {lang[clang].about_pbl[name]}
                <span className="about-pbl__menu-list__item--img"></span>
            </NavLink>
            {children && children.length ? <AboutPblMenu items={children} /> : null}
        </li>
    );
};

AboutPblMenuItem.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default withRouter(connect(mapStateToProps)(AboutPblMenuItem));



// WEBPACK FOOTER //
// ./src/components/about/AboutPblMenuItem.js